"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var service_service_1 = require("src/app/Services/service.service");
var forms_1 = require("@angular/forms");
var register_component_1 = require("./../../../User/register/register.component");
var common_1 = require("@angular/common");
var RegistrationComponent = /** @class */ (function (_super) {
    __extends(RegistrationComponent, _super);
    function RegistrationComponent(_location, fb, service) {
        var _this = _super.call(this, fb, service, null) || this;
        _this._location = _location;
        _this.service = service;
        _this.enablePhoneRegConfirm = false;
        _this.successRegister = false;
        _this.loading = false;
        _this.enablePhoneRegConfirm = service.enablePhoneRegConfirm;
        return _this;
    }
    RegistrationComponent.prototype.onSubmit = function () {
        var _this = this;
        this.validateAllFormFields(this.registrationForm);
        if (!this.registrationForm.invalid) {
            if (!this.isCaptchaOk()) {
                this.services.showError("Please confirm the captcha");
            }
            else {
                this.loading = true;
                this.service.userService
                    .register(this.registrationForm.controls["email"].value, this.registrationForm.controls["phone"].value, this.registrationForm.controls["password"].value, this.registrationForm.controls["passwordConfirm"].value, "registration-success")
                    .then(function (r) {
                    _this.successRegister = true;
                    setTimeout(function () {
                        _this.service.route.navigate(["/"]);
                        _this.loading = false;
                    }, 2000);
                })
                    .catch(function (e) {
                    _this.loading = false;
                    _this.service.showError(e);
                });
            }
        }
    };
    RegistrationComponent.prototype.locationBack = function () {
        this._location.back();
    };
    return RegistrationComponent;
}(register_component_1.RegisterComponent));
exports.RegistrationComponent = RegistrationComponent;
